import { toast } from "react-toastify";

export const showSuccessToast = (message: string) => {
  toast.dismiss("success-toast");

  toast.success(message, {
    toastId: "success-toast",
  });
};

export const showErrorToast = (message: string) => {
  toast.dismiss("error-toast");

  toast.error(message, {
    toastId: "error-toast",
  });
};